export const BRANCH_STORAGE_KEY = "selectedBranchId";

export function getStoredBranchId() {
  return localStorage.getItem(BRANCH_STORAGE_KEY) || "";
}

export function setStoredBranchId(branchId) {
  if (!branchId) {
    localStorage.removeItem(BRANCH_STORAGE_KEY);
    return;
  }
  localStorage.setItem(BRANCH_STORAGE_KEY, branchId);
}
